// these GUID consts are defined on server too
//  - first page has an ID but we might not know what it is when we start a briefing
//  - last page (test results, 'BriefingDone') has no ID and is 'hard-coded'
//  - all pages for printable version
export const allPagesID: string = "AAAAAAAA-AAAA-AAAA-AAAA-AAAAAAAAAAAA";
export const firstPageID: string = "11111111-1111-1111-1111-111111111111";
export const lastPageID: string = "99999999-9999-9999-9999-999999999999";
export const previewVisitID: string = "36ceb4f8-271a-4d64-ff02-f14236aad652"; // converts on server to known value

// Same as TriState in Visual Basic
export enum TriState {
    UseDefault = -2, // 0xFFFFFFFE
    True = -1, // 0xFFFFFFFF
    False = 0
}

// NB - there's logic in UserDialogue.roleList that depends on lesser roles having higher numeric values
export enum UserRole {
    None = 0, // not signed in
    Admin = 1,
    Client = 2,
    Site = 3,
    SitePathways = 4,
    SiteSponsors = 5
}

export enum UserStatus {
    None = 0,
    InitialEmailPending = 1,
    InitialEmailSent = 2,
    InitialEmailFailed = 3,
    EmailConfirmed = 4, // means they followed the initial email link
    Active = 5 // means they set a password
}

export enum LookupGroup {
    All = 0,
    LookupOne = 1,
    LookupTwo = 2
}

export enum RegistrationFieldType {
    None = 0,
    SingleText = 1,
    MultiLineText = 2,
    YesNo = 3,
    Date = 4
}

// if adding any NEW components, see README.md (New PagePart Component Check-List)
export enum PagePartComponent {
    None = 0,
    Text = 1,
    Note = 2,
    Map = 3,
    ResourceAndText = 4,
    RadioChoice = 5,
    CheckboxChoices = 6,
    FreeText = 7,
    Download = 8,
    PhotoCapture = 9,
    ConfirmToContinue = 10,
    PasscodeToContinue = 11
}

export enum ResourceAndTextLayout {
    Default = 0,
    TextOnLeft = 1,
    TextOnRight = 2,
    NoText = 3,
    TextAbove = 4,
    TextBelow = 5
}

export enum QuestionTextLayout {
    Default = 0,
    QuestionOnLeft = 1,
    QuestionAbove = 2
}

export enum ResourceContentType {
    None = 0,
    Image = 1,
    Audio = 2,
    Video = 3,
    Download = 4,
    Vimeo = 5,
    Wistia = 6,
    Momento = 7
}

export enum BannerOption {
    Solid = 0,
    RoundedBox = 1,
    Gradient = 2,
    NoSiteSentinelLogo = 3
}

// just for search parameters
export enum VisitStatus {
    None = 0,
    Registered = 1,
    BriefingStarted = 2,
    TestStarted = 3,
    Completed = 4,
    CompletedAndPassed = 5
}

export enum SiteRegistrationType {
    None = 0,
    WithEmail = 1,
    WithoutEmail = 2
}

export enum WorkPermitFormType {
    None = 0,
    // SouthEasternPrototype = 1,
    SouthEastern = 2,
    SwmScapa = 3
}

export enum WorkPermitEventType {
    // statuses
    None = 0,
    Draft = 1,
    Issued = 2,
    IssuedExpired = 3,
    Surrendered = 4,
    Closed = 5,

    //other recorded events
    SignatureRequestSent = 20,
    Signed = 21,
    SurrenderReminderSent = 22
}

export enum EmailLogObjectType {
    None = 0,
    Visit,
    SiteRecipient,
    WorkPermit,
    User
}